import { lazyWithRetry as lazy } from './lazyWithRetry';
import { withProtected } from './withProtected';
import { withFeatureFlag } from './withFeatureFlag';

export const myJourney = [
	{
		path: '/journey/',
		Component: withFeatureFlag(withProtected(lazy(() => import('../pages/MyJourney'))), 'my-journey-enabled'),
		handle: {
			key: 'pages.journey.title'
		},
		children: [
			{
				path: '/journey/my-profiles',
				Component: lazy(() => import('../pages/MyJourney/Dashboard'))
			},
			{
				path: '/journey/portal/search-company',
				Component: lazy(() => import('../pages/MyJourney/Portal/SearchCompany/Search'))
			},
			{
				path: '/journey/portal/search-company/:profileId',
				Component: lazy(() => import('../pages/MyJourney/Portal/SearchCompany/DetailedProfile'))
			},
			{
				path: '/journey/portal/search-university',
				Component: lazy(() => import('../pages/MyJourney/Portal/SearchEducational/Search'))
			},
			{
				path: '/journey/portal/search-university/:profileId',
				Component: lazy(() => import('../pages/MyJourney/Portal/SearchEducational/DetailedProfile'))
			},
			{
				path: '/journey/portal',
				Component: lazy(() => import('../pages/MyJourney/Portal/ChooseType'))
			},
			{
				path: '/journey/browse/:organisationType',
				Component: lazy(() => import('../pages/MyJourney/Browse')),
				handle: {
					key: 'pages.journey.browse.title'
				}
			},
			{
				path: '/journey/my-enquiries',
				Component: lazy(() => import('../pages/MyJourney/Enquiries')),
				handle: {
					key: 'pages.journey.enquiries.title'
				}
			}
		]
	}
];
